import { InfoPopover, InfoPopoverProps } from '@adsk/alloy-react-tooltip';
import PropTypes from 'prop-types';
import { forwardRef, FunctionComponent, RefAttributes } from 'react';
import styled from 'styled-components';

const ICON_STYLE = {
  marginLeft: 5,
  height: 16,
};

const Message = styled.div`
  white-space: pre-line;
`;

export const FormFieldInfoPopover: FunctionComponent<
  InfoPopoverProps & RefAttributes<HTMLDivElement>
> = forwardRef(({ message, ...props }, ref) => (
  <InfoPopover
    style={ICON_STYLE}
    ref={ref}
    message={<Message>{message}</Message>}
    placement={InfoPopover.PLACEMENTS.TOP}
    {...props}
  />
));

FormFieldInfoPopover.propTypes = {
  message: PropTypes.node.isRequired,
};
